import React from "react";
import styled, { css } from 'styled-components';
const StyledLanguageSelection = styled.div `
  position: relative;
  
  ${props => props.onlyShowOnMobile && css `
    @media only screen and (min-width: 768px) {
        display: none;
    }
  `};
  
  ${props => props.hideOnMobile && css `
    display: none;
    
    @media only screen and (min-width: 768px) {
      display: block;
    }
  `};
  
  ${props => props.isAuthVersion && css `
      position: absolute;
      bottom: 20px;
      right: 20px;
    
      @media only screen and (min-width: 768px) {
        top: 80px;
        right: 70px;
      }
`};
`;
const LanguageSelection = ({ children, onlyShowOnMobile, hideOnMobile, isAuthVersion }) => (React.createElement(StyledLanguageSelection, { onlyShowOnMobile: onlyShowOnMobile, hideOnMobile: hideOnMobile, isAuthVersion: isAuthVersion }, children));
export default LanguageSelection;
